import React, { FC } from "react";
import BookingDetailsSkeleton from "containers/CheckOutPage/components/skeletons/skeletonBookingDetails";
import SectionDateRangeSkeleton from "containers/ListingDetailPage/listing-stay-detail/skeleton/SectionDateSkeleton";

export interface StayCardHProps {
  className?: string;
  data?: any;
}

const StayCardAlternativeSkeleton: FC<StayCardHProps> = ({ className = "" }) => {
  const renderTienIch = () => {
    return (
      <div className="flex flex-col h-full space-y-4 animate-pulse">
        {/* Guest Information Skeleton */}
        <div className="flex items-center space-x-3">
          <div className="w-6 h-6 bg-gray-300 dark:bg-gray-700 rounded-full"></div>
          <div className="w-24 h-4 bg-gray-300 dark:bg-gray-700 rounded-md"></div>
        </div>

        {/* Title Skeleton */}
        <div className="w-48 h-6 bg-gray-300 dark:bg-gray-700 rounded-md"></div>

        {/* Address Skeleton */}
        <div className="w-64 h-4 bg-gray-300 dark:bg-gray-700 rounded-md"></div>

        {/* Button Skeleton */}
        <div className="mt-auto w-full h-10 bg-gray-300 dark:bg-gray-700 rounded-md"></div>
      </div>
    );
  };

  const renderSliderGallery = () => {
    return (
      <div className="flex flex-col gap-6 items-center animate-pulse">
        {/* Image Skeleton */}
        <div className="relative w-full max-w-[500px] h-[300px] bg-gray-300 dark:bg-gray-700 rounded-lg"></div>

        {/* Price Overlay Skeleton */}
        <div className="absolute bottom-4 right-4 bg-gray-400 dark:bg-gray-600 text-transparent text-lg font-semibold px-3 py-1 rounded-lg shadow-lg">
          $XXX/night
        </div>

        {/* Tien Ich Skeleton */}
        <div className="w-full max-w-[500px] px-4">{renderTienIch()}</div>
      </div>
    );
  };

  return (
    <div
      className={`nc-StayCardH group relative bg-gray-100 dark:bg-neutral-800 border border-gray-300 dark:border-gray-700 rounded-2xl overflow-hidden shadow-md transition-shadow ${className}`}
      data-nc-id="StayCardH"
    >
      <div className="flex flex-col md:flex-row gap-4 sm:pb-0 lg:pb-6 xl:pb-0">
        {renderSliderGallery()}
      <SectionDateRangeSkeleton/>
      </div>
    </div>
  );
};

export default StayCardAlternativeSkeleton;